var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('img',{class:[_vm.isFullImg ? 'fullImg' : 'normalImg'],attrs:{"src":_vm.propValue.file_down_path}})])}
var staticRenderFns = []

export { render, staticRenderFns }